import { useEffect, useState } from "react";
import {
  ScorecardSearchRequestCore,
  ScorecardLicenseSummaryDataCore,
  filterColumnValues,
} from "../../Component/Model/Dto/ScorecardLicense";
import { userRolesState} from "../../State/user.Atom";
import { SiteAdminRole, UserAdminRole } from "../../Component/Common/Constants/UserRoles";
import { useRecoilValue } from "recoil";
import { defaultObject } from "../../Component/Model/helpers";
import { EntriesPerPage } from "../../Component/Model/Table/Table";
import { ScorecardTableMapper } from "./GroupDataManagementBase/GroupDataManagementTable";
import { DataTable } from "../../Component/Common/Components/DataTable/DataTable";
import {
  ColumnSortOption
} from "../../Component/Model/Dto/ColumnSortOption";
import { ConfirmationDialog } from "../../Component/Common/Components/ConfirmationDialog";
import { toast } from "react-toastify";
import { BEEScorecardService } from "../../Component/Api/BEEScorecard/BEEScorecard";
import {
  FilterType,
  IFilter,
} from "../../Component/Common/Components/DataTable/Filters";
import { CoreStaticDataService } from "../../Component/Api/StaticData/CoreStaticDataService";
import { UserService } from "../../Component/Api/User/UserService";
import { GetYearsRange } from "../../Helpers/yearGeneratorFromCurrent";
import { Dialog, DialogContent } from "@mui/material";
import { CustomDialogTitle } from "../Common/Custom/CustomDialogTitle";
import { AssignModal } from "../BEEScorecards/AssignModal";
import { ScorecardLicenseModal } from "../BEEScorecards/ScorecardLicenses/ScorecardLicenseModal/ScorecardLicenseModal";

export const GroupDataManagementBase = () => {
  const [UserNames, setUserNames] =
    useState<filterColumnValues[]>(defaultObject);
  const [BeeScoreCardType, setBeeScoreCardType] =
    useState<filterColumnValues[]>(defaultObject);
  const [YearsRange, setYearsRange] =
    useState<filterColumnValues[]>(defaultObject);
  const [scorecardYears, setScorecardYears] = useState<[]>([]);
  const [scorecardUsers, setScorecardUsers] = useState<[]>([]);
  const [scorecardsTypeIds, setScorecardsTypeIds] = useState<[]>([]);
  const [scorecardConsolidation, setScorecardConsolidation] =
    useState<any>(null);
  const [filteredItemsCount, setFilteredItemsCount] = useState<number>(0);
  const [totalItemsCount, setTotalItemsCount] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [searchValue, setSearchValue] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [columnSortOptions, setColumnSortOptions] = useState<ColumnSortOption[]>([]);
  const [showModal, setShowModal] = useState<boolean>(false);

  const [scorecardData, setScorecardData] =
    useState<ScorecardLicenseSummaryDataCore[]>(defaultObject);
  const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({
    defaultValue: 10,
  });

  const [showConfirmationDialog, setShowConfirmationDialog] =
    useState<boolean>(false);
  const [selectedScorecardId, setSelectedScorecardId] = useState<string>("");
  const [showAssignModal, setShowAssignModal] = useState<boolean>(false);

  const GetUsers = async () => {
    const users = await UserService.getNonAdminUsers();
    setUserNames(
      users.data.map((data) => {
        return { key: data.username, val: data.username };
      })
    );
  };

  const userRoles = useRecoilValue(userRolesState);

  const GetScorecardType = async () => {
    const scorecardType = await CoreStaticDataService.getBeeScorecardType();
    setBeeScoreCardType(
      scorecardType.data.map((data) => {
        return { key: data.name, val: data.id };
      })
    );
  };

  const SetYears = () => {
    const yearsBehind = 10;
    const yearsAhead = 2;
    const years = GetYearsRange(yearsBehind, yearsAhead);
    setYearsRange(
      years.map((data) => {
        return { key: data.toString(), val: data };
      })
    );
  };

  const entriesPerPageChanged = (entriesPerPage: number) => {
    setEntriesPerPage({ defaultValue: entriesPerPage });
    setPageNumber(1);
  };

  const pageNumberChanged = (pageNumber: number) => {
    setPageNumber(pageNumber);
  };

  const searchValueChanged = (updatedSearchValue: string) => {
    setSearchValue(updatedSearchValue);
  };

  let userSearchRequest: ScorecardSearchRequestCore = {
    pageNumber: pageNumber,
    pageSize: entriesPerPage.defaultValue!,
    searchValue: searchValue,
    years: [],
    scorecardTypeIds: [],
    createdByUserNames: [],
    isGroupDataManagement: true,
    columnSortOptions: []
  };

  const columnSortingChanged = (sortOption: ColumnSortOption) => {
    setColumnSortOptions([sortOption]);
    setPageNumber(1);
  }
  const searchScorecardData = async () => {
    setIsLoading(true);
    try {
      const years: [] = scorecardYears;
      const scorecardTypeIds: [] = scorecardsTypeIds;
      const createdByUserNames: [] = scorecardUsers;
      const isConsolidated: any = scorecardConsolidation;
      userSearchRequest = {
        ...userSearchRequest,
        years,
        scorecardTypeIds,
        isConsolidated,
        createdByUserNames,
        columnSortOptions
      };
      const scorecardSearchResult =
        await BEEScorecardService.getUserScorecardsCore(userSearchRequest);
      setScorecardData(scorecardSearchResult.data.results);
      setFilteredItemsCount(scorecardSearchResult.data.filteredItemsCount);
      setTotalItemsCount(scorecardSearchResult.data.totalItemsCount);
    } catch (error) {
      console.log(error);
      setScorecardData(defaultObject);
      setFilteredItemsCount(0);
      setTotalItemsCount(0);
    } finally {
      setIsLoading(false);
    }
  };
  const scorecardLicensesFilterData: Array<IFilter> = [
    {
      label: "Scorecard Type:",
      values: BeeScoreCardType,
      type: FilterType.multiselect,
      propname: "scorecardTypeIds",
    },
    {
      label: "Is Consolidated:",
      values: [
        { key: "Yes", val: true },
        { key: "No", val: false },
      ],
      type: FilterType.select,
      propname: "isConsolidated",
    },
    {
      label: "User Name",
      values: UserNames,
      type: FilterType.multiselect,
      propname: "createdByUserNames",
    },
    {
      label: "Year:",
      values: YearsRange,
      type: FilterType.multiselect,
      propname: "years",
    },
  ];

  const confirmDeleteMessage =
    "Are you sure you want to delete this scorecard?";

  const filtersChanged = async (filterProps: any) => {
    setPageNumber(1);
    const years = filterProps["years"];
    const scorecardTypeIds = filterProps["scorecardTypeIds"];
    const isConsolidated =
      filterProps["isConsolidated"].length == 0
        ? null
        : filterProps["isConsolidated"];
    const createdByUserNames = filterProps["createdByUserNames"];
    setScorecardYears(years);
    setScorecardsTypeIds(scorecardTypeIds);
    setScorecardConsolidation(isConsolidated);
    setScorecardUsers(createdByUserNames);
  };

  const handleCloseConfirmation = () => {
    setShowConfirmationDialog(false);
    setSelectedScorecardId("");
  };

  const showDeleteConfirmation = (id: string) => {
    setSelectedScorecardId(id);
    setShowConfirmationDialog(true);
  };

  const handleDelete = async () => {
    try {
      await BEEScorecardService.deleteScorecard(selectedScorecardId);
      toast.success("Successfully deleted scorecard");
      searchScorecardData();
    } catch (error) {
      console.log(error);
    } finally {
      handleCloseConfirmation();
    }
  };

  useEffect(() => {
    GetUsers();
    GetScorecardType();
    SetYears();
  }, []);

  useEffect(() => {
    searchScorecardData();
  }, [
    entriesPerPage,
    pageNumber,
    columnSortOptions,
    searchValue,
    scorecardYears,
    scorecardsTypeIds,
    scorecardConsolidation,
    scorecardUsers
  ]);

  const closeAssignUserModal = () => {
    setSelectedScorecardId("");
    setShowAssignModal(false);
  };

  const handleAssignUser = (id: string) => {
    setSelectedScorecardId(id);
    setShowAssignModal(true);
  };

  const tableData = ScorecardTableMapper(
    scorecardData,
    handleAssignUser,
    showDeleteConfirmation
  );

  const handleAddScoredcard = () => {
    setShowModal(true);
  };

  const bulkActions = [
    {
      label: "Create Module",
      action: handleAddScoredcard,
    },
  ];

  return (
    <>
      <DataTable
        key={totalItemsCount}
        table={tableData}
        canSearch
        entriesPerPage={entriesPerPage}
        pageNumber={pageNumber}
        filteredItemsCount={filteredItemsCount}
        totalItemsCount={totalItemsCount}
        entriesPerPageChanged={entriesPerPageChanged}
        pageNumberChanged={pageNumberChanged}
        searchValueChanged={searchValueChanged}
        isLoading={isLoading}
        manualSorting={true}
        columnSortingChanged={columnSortingChanged}
        filters={scorecardLicensesFilterData}
        filtersChanged={filtersChanged}
        {...(((userRoles.includes(SiteAdminRole) || userRoles.includes(UserAdminRole))) ? { bulkActions } : {})}
      ></DataTable>
      <ConfirmationDialog
        showDialog={showConfirmationDialog}
        handleAccept={handleDelete}
        handleCancel={handleCloseConfirmation}
        heading={"Confirm Delete"}
        message={confirmDeleteMessage}
      />
      {showAssignModal && (
        <AssignModal
          isOrganisationUserAccess={false}
          id={selectedScorecardId}
          showAssignModal={showAssignModal}
          closeAssignModal={closeAssignUserModal}
        />
      )}
      <Dialog
        open={showModal}
        onClose={() => setShowModal(false)}
        aria-labelledby="form-dialog-title"
        maxWidth="xl"
      >
        <CustomDialogTitle
          id="customized-dialog-title"
          onClose={() => setShowModal(false)}
        >
          Add Module
        </CustomDialogTitle>
        <DialogContent>
          <ScorecardLicenseModal modalDescription={"Summary of Group Data Management Module Licenses"} isGroup={true} />
        </DialogContent>
      </Dialog>
    </>
  );
};
